import { getDetailedErrorMessage } from "../../../utils/validation";
export class PublisherGroupFetchFailed extends Error {
    constructor(apiError, fallbackMessage = "Please try again at a later time.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PublisherGroupFetchFailed);
        }
        this.name = "PublisherGroupFetchFailed";
        this.message = `Failed to fetch publisher group(s). ${getDetailedErrorMessage(apiError, fallbackMessage)}`;
    }
}
export class PublisherGroupSaveFailed extends Error {
    constructor(apiError, fallbackMessage = "Please try again at a later time.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PublisherGroupSaveFailed);
        }
        this.name = "PublisherGroupSaveFailed";
        this.message = `Failed to save publisher group. ${getDetailedErrorMessage(apiError, fallbackMessage)}`;
    }
}
//# sourceMappingURL=errors.js.map